import {Component, Input, OnInit} from '@angular/core';
import {ParentService} from '@app/dashboard/services/parent.service';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {Path} from "@core/enums";

@Component({
  selector: 'app-pending-reviews',
  templateUrl: './pending-reviews.component.html',
  styleUrls: ['./pending-reviews.component.scss', '../active-reviews/active-reviews.component.scss']
})
export class PendingReviewsComponent implements OnInit {

  isMobileDevice: boolean;
  draftReviews = []; // All pending/drafts reviews will store here
  areaOfFocusId: string;
  areaOfFocus = [];

  constructor(
    private parentService: ParentService,
    private toastrService: ToastrService,
    private router: Router
  ) {
    this.isMobileDevice = true;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      this.isMobileDevice = true;
    } else {
      this.isMobileDevice = false;
    }
  }


  ngOnInit(): void {
    this.loadAreasOfFocus();
  }

  goToPaymentPage(gabadooId){
    console.log('here');
    this.router.navigate([`draft-gabadoo/` + gabadooId ]);
  }

  loadAreasOfFocus() {
    this.parentService.getAreasOfFocus().subscribe((response) => {
      if (response.status === 200) {
        const areaOfFocusDetails = response.body.result;
        this.areaOfFocus.push.apply(this.areaOfFocus, areaOfFocusDetails);        // tslint:disable-next-line:no-shadowed-variable
        this.parentService.getPendingGabadooReviews().subscribe((response) => {
          console.log('response', response);
          if (response.status === 200){
            this.draftReviews = response.body.result;
            this.assignCorrectProblemNamesToCards(response.body.result);
          }
        }, (error => this.toastrService.info('Error while fetching drafts, please try again')));
      } else {
        this.toastrService.error('Encountered problem loading Areas Of Focus Info', 'Error!');
      }
    }, (error => this.toastrService.error(error, 'Error!')));
  }

  // tslint:disable-next-line:variable-name
  assignCorrectProblemNamesToCards(_responseArray){
    _responseArray.forEach((element, index) => {
      this.areaOfFocusId = element.reviewDetails.areaOfFocus;
      const selectedAreaFocusDetail = this.areaOfFocus.find(area => area._id === this.areaOfFocusId);
      this.draftReviews[index].reviewDetails.areaOfFocus = selectedAreaFocusDetail.problemName;
    });
  }
}
